import request from '@/utils/request'

export function selectProjectTaskList(params) {
  return request({
    url: '/api/v1.0/projectTask/list',
    method: 'get',
    params:params
  })
}

export function selectProjectTaskListByAccount(params) {
  return request({
    url: '/api/v1.0/projectTask/list/by-account',
    method: 'get',
    params:params
  })
}

export function selectAllProjectTask() {
  return request({
    url: '/api/v1.0/projectTask/list/all',
    method: 'get',
    params:{}
  })
}

export function selectProjectTask(id) {
  return request({
    url: '/api/v1.0/projectTask/'+id,
    method: 'get',
    params:{}
  })
}


export function addProjectTask(data) {
  return request({
    url: '/api/v1.0/projectTask/add',
    method: 'post',
    data: data
  })
}

export function updateProjectTask(data) {
  return request({
    url: '/api/v1.0/projectTask/update',
    method: 'post',
    data: data
  })
}

export function deleteProjectTask(data) {
  return request({
    url: '/api/v1.0/projectTask/delete',
    method: 'delete',
    data: data
  })
}

export function querySelectedStudents(id) {
  return request({
    url: '/api/v1.0/projectTask/query/selected-students/'+id,
    method: 'get',
    params:{}
  })
}
